// extracted by mini-css-extract-plugin
export var roadmapSection = "index-module--roadmap-section--0Ud19";
export var roadmapSectionContainer = "index-module--roadmap-section-container--wHTqb";
export var decoration = "index-module--decoration--0OUG7";
export var roadmapTitle = "index-module--roadmapTitle--3sxQj";
export var card = "index-module--card--5ECts";
export var cardBg = "index-module--card-bg--Pv6g-";
export var cardTitle = "index-module--card-title--yd11T";
export var cardDescription = "index-module--card-description--S7-56";
export var cardLabel = "index-module--card-label--W5SKM";
export var cardLabelBig = "index-module--card-label-big--BAcKY";
export var cardLabelImage = "index-module--card-label-image--kZLEF";
export var cardLabelText = "index-module--card-label-text--mCh5J";
export var cardLabelEven = "index-module--card-label-even--w5GlU";
export var cardLabelImageFlipped = "index-module--card-label-image-flipped--WlrZa";